import React from 'react';
import Dropzone from 'react-dropzone';
// import CurrencyInput from 'react-currency-input-field';
import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import axios from 'axios';
import { Toaster, toast } from 'react-hot-toast';
import { getToken } from '../../hooks/AuthProvider';
import { Link } from 'react-router-dom';
// import { authClient } from "../hooks/authClient";
// import clerk from '../../utils/clerk';

type props = { onBehalfOf?: string };
type state = {
    files: any[];
    acceptedFiles: any[];
    rejectedFiles: any[];
    value: number;
    submitted: boolean;
    title: string;
    description: string;
    disableComments: boolean;
    scheduleRelease: string;
    fileIdMap: { [key: string]: number }; // Maps fileID to local file index
    apiFileStatuses: { [key: string]: any }; // Maps fileID to API file data
    showPriceWarningModal: boolean;
    pendingSubmit: boolean; // Track if we're waiting for modal confirmation
    isFreePlan: boolean; // Track if creator has subscription plans
};

export default class CreatePost extends React.Component<props, state> { 
    title: any;
    description: any;
    price: any;
    fileUpload: any;
    submitBTN: any;

    constructor(props: any) {
        super(props);
        this.state = {
            files: [],
            acceptedFiles: [],
            rejectedFiles: [],
            submitted: false,
            value: 0.00,
            title: '',
            description: '',
            disableComments: false,
            scheduleRelease: '',
            fileIdMap: {},
            apiFileStatuses: {},
            showPriceWarningModal: false,
            pendingSubmit: false,
            isFreePlan: false
        }
        this.onDrop = this.onDrop.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.title = React.createRef();
        this.description = React.createRef();
        this.price = React.createRef();
        this.fileUpload = React.createRef();
        this.submitBTN = React.createRef();
    }

    componentDidMount() {
        // Check if creator has subscription plans
        axios.get(`${process.env.REACT_APP_API_URL}api/v1/creator/plans`, {
            headers: { 'x-auth-token': getToken() }
        }).then((res) => {
            if (res.data.valid) {
                // If plans array is empty, user is on free plan
                const isFree = !res.data.plans || res.data.plans.length === 0;
                this.setState({ isFreePlan: isFree });
            }
        }).catch(err => {
            console.error('Error checking subscription plans:', err);
        });
    }

    onDrop = async (files: any[]) => {
        // Handle FileSystemFileHandle objects by extracting the actual File
        const processedFiles = await Promise.all(
            files.map(async (file: any) => {
                // If it's a FileSystemFileHandle, get the actual File
                if (file.handle && typeof file.handle.getFile === 'function') {
                    try {
                        const actualFile = await file.handle.getFile();
                        return actualFile;
                    } catch (err) {
                        console.error('Error getting file from handle:', err);
                        return file;
                    }
                }
                // If it's already a File object, use it directly
                if (file instanceof File) {
                    return file;
                }
                // Otherwise, try to use it as-is (might be a File-like object)
                return file;
            })
        );
        
        this.setState({files: processedFiles});
    };

    costPrice = (value: any) => {
        if (value === '' || value === 0 || value === 0.0 || value === 0.00) {
            this.setState({value: 0.00});
        } else {
            this.setState({value: value.slice(1).replace(/,/g, '')});
        }
    }

    changeComments(e: any) {
        console.log(e.target.checked);
        this.setState({disableComments: e.target.checked});
    }

    async submitForm(e: any) {
        e.preventDefault();

        // Validate required fields
        if (!this.state.title || this.state.title.trim() === '') {
            toast.error('Title is required!', {
                style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }
            });
            return;
        }

        const hasFiles = this.state.files && this.state.files.length > 0;

        // Description is optional when files are attached
        const hasPrice = this.state.value > 0;

        // If no files but price is set, show warning modal
        if (!hasFiles && hasPrice) {
            this.setState({ showPriceWarningModal: true, pendingSubmit: true });
            return;
        }

        // Proceed with submission
        await this.proceedWithSubmission(hasFiles);
    }

    handleModalConfirm = async () => {
        this.setState({ showPriceWarningModal: false });
        await this.proceedWithSubmission(false);
    }

    handleModalCancel = () => {
        this.setState({ showPriceWarningModal: false, pendingSubmit: false });
    }

    async proceedWithSubmission(hasFiles: boolean) {
        this.title.current.disabled = true;
        this.description.current.disabled = true;
        this.fileUpload.current.disabled = true;
        this.submitBTN.current.classList.toggle('hidden');

        // Only disable price field if there are files
        if (hasFiles) {
            this.price.current.disabled = true;
            if (document.getElementById('price-input')) {
                var price = document.getElementById('price-input') as HTMLInputElement;
                price.disabled = true;
            }
        }

        // If no files, create post without file upload logic
        if (!hasFiles) {
            try {
                // const realToken = await axios.post(`${process.env.REACT_APP_API_URL}api/v1/genUploadToken`, null, { headers: { 'x-auth-token': getToken() }});
                
                const response = await axios.post(
                    `${process.env.REACT_APP_API_URL}api/v2/create/post`,
                    {
                        title: this.state.title,
                        description: this.state.description,
                        price: '0', // Price is always 0 for posts without files
                        files: [],
                        ...(this.props.onBehalfOf ? { onBehalfOf: this.props.onBehalfOf } : {}),
                    },
                    {
                        headers: { 'x-auth-token': getToken() },
                    }
                );

                if (response.data.valid) {
                    const { postID } = response.data;
                    
                    // Poll for completion status (though it should be immediate for no-file posts)
                    var interval = setInterval(() => {
                        axios.get(`${process.env.REACT_APP_API_URL}api/v2/create/post/${postID}`, {
                            headers: { 'x-auth-token': getToken() }
                        }).then((res) => {
                            console.log(res.data);
                            
                            if (res.data.complete === true) {
                                clearInterval(interval);
                                window.onbeforeunload = null;
                                toast.success('Post created successfully!', {
                                    style: {
                                        color: '#ffffff',
                                        backgroundColor: '#242C37',
                                    }
                                });
                                window.location.href = `/app/user/${res.data.username}`;
                            }
                        }).catch(err => {
                            console.log(err);
                            clearInterval(interval);
                            window.onbeforeunload = null;
                        });
                    }, 5000);
                } else {
                    throw new Error('Failed to create post');
                }
            } catch (err: any) {
                console.log(err);
                toast.error(err.response?.data?.error || 'Failed to create post!', {
                    style: {
                        color: '#ffffff',
                        backgroundColor: '#242C37',
                    }
                });
                // Re-enable form on error
                this.title.current.disabled = false;
                this.description.current.disabled = false;
                this.fileUpload.current.disabled = false;
                this.submitBTN.current.classList.toggle('hidden');
            }
            return;
        }

        // Original file upload logic continues here
        // Extract file metadata FIRST (before state update that might lose File properties)
        const originalFiles = this.state.files;
        const fileMetadata = originalFiles.map((file: any, index: number) => {
                // File objects should have .name, .size, and .type properties
                const fileName = file.name || '';
                const fileSize = file.size || 0;
                const mimetype = file.type || '';
                
                console.log(`File ${index} metadata:`, { 
                    name: fileName, 
                    size: fileSize, 
                    mimetype, 
                    type: file.type,
                    isFile: file instanceof File,
                    allKeys: file ? Object.keys(file) : []
                });
                
                if (!fileName) {
                    console.error(`File ${index} is missing name property:`, file);
                    throw new Error(`File at index ${index} is missing name property`);
                }
                
                if (!fileSize || fileSize === 0) {
                    console.warn(`File ${index} has invalid size:`, fileSize);
                }
                
                return {
                    name: fileName,
                    size: fileSize,
                    mimetype: mimetype,
                };
            });

            // Now update files with upload start time and initial status
            // Preserve the original File object by wrapping it in an object
            this.setState((prevState) => ({
                files: prevState.files.map((file: any, index: number) => {
                    // Create a wrapper object that preserves the File object
                    const fileWrapper: any = {
                        file: file, // Store original File object
                        status: 'Preparing...',
                        progress: 0,
                        estimatedTime: 'Calculating...',
                        uploadStartTime: new Date(),
                    };
                    // Copy File properties to wrapper for easy access
                    if (file instanceof File) {
                        fileWrapper.name = file.name;
                        fileWrapper.size = file.size;
                        fileWrapper.type = file.type;
                    } else {
                        // If not a File, try to preserve existing properties
                        Object.assign(fileWrapper, file);
                    }
                    return fileWrapper;
                })
            }));

            try {
                // Step 1: Get presigned URLs from server
                // const realToken = await axios.post(`${process.env.REACT_APP_API_URL}api/v1/genUploadToken`, null, { headers: { 'x-auth-token': getToken() }});
                
                console.log('Sending fileMetadata:', JSON.stringify(fileMetadata, null, 2));

                const presignResponse = await axios.post(
                    `${process.env.REACT_APP_API_URL}api/v2/create/post`,
                    {
                        title: this.state.title,
                        description: this.state.description,
                        price: this.state.value.toString(),
                        files: fileMetadata,
                        ...(this.props.onBehalfOf ? { onBehalfOf: this.props.onBehalfOf } : {}),
                    },
                    {
                        headers: { 'x-auth-token': getToken() },
                    }
                );

                if (!presignResponse.data.valid) {
                    throw new Error('Failed to get presigned URLs');
                }

                const { presignedUrls, postID, files: apiFiles } = presignResponse.data;

                // Store mapping of fileID to local file index for status updates
                const fileIdToIndexMap: { [key: string]: number } = {};
                presignedUrls.forEach((presigned: any, index: number) => {
                    fileIdToIndexMap[presigned.fileID] = index;
                });
                
                // Update files state to include fileID for each file
                this.setState((prevState) => ({
                    fileIdMap: fileIdToIndexMap,
                    files: prevState.files.map((file: any, index: number) => {
                        const presigned = presignedUrls[index];
                        return {
                            ...file,
                            fileID: presigned?.fileID, // Store fileID for matching with API response
                            status: 'Uploading',
                        };
                    })
                }));

                // Step 2: Upload each file directly to S3 using presigned URLs
                const uploadPromises = presignedUrls.map(async (presigned: any, index: number) => {
                    const fileWrapper = this.state.files[index];
                    if (!fileWrapper) return { fileID: presigned.fileID, success: false };

                    // Extract the File object from the wrapper
                    let fileToUpload: File;
                    const file = fileWrapper.file || fileWrapper; // Get original File from wrapper or use wrapper itself
                    
                    if (file instanceof File) {
                        fileToUpload = file;
                    } else if (file.handle && typeof file.handle.getFile === 'function') {
                        // Get the actual File from the handle
                        fileToUpload = await file.handle.getFile();
                    } else {
                        console.error(`File at index ${index} is not a valid File object:`, file);
                        return { fileID: presigned.fileID, success: false };
                    }

                    const uploadStartTime = new Date().getTime();

                    try {
                        await axios.put(presigned.presignedUrl, fileToUpload, {
                            headers: {
                                'Content-Type': fileToUpload.type || presigned.contentType || 'application/octet-stream',
                            },
                            onUploadProgress: (progressEvent) => {
                                const { loaded, total } = progressEvent;
                                if (total) {
                                    const progress = Math.round((loaded * 100) / total);
                                    const timeElapsed = (new Date().getTime() - uploadStartTime) / 1000;
                                    const uploadSpeed = loaded / timeElapsed;
                                    const estimatedTime = Math.round((total - loaded) / uploadSpeed);

                                    this.setState((prevState) => {
                                        const updatedFiles = prevState.files.map((f, idx) => {
                                            if (idx === index) {
                                                return {
                                                    ...f,
                                                    progress,
                                                    estimatedTime: this.formatTime(estimatedTime),
                                                };
                                            }
                                            return f;
                                        });
                                        return { files: updatedFiles };
                                    });
                                }
                            },
                        });

                        return {
                            fileID: presigned.fileID,
                            success: true,
                            s3Key: presigned.s3Key,
                            originalName: fileToUpload.name, // Include original filename for packager
                        };
                    } catch (err) {
                        console.error(`Failed to upload file ${fileToUpload.name}:`, err);
                        this.setState((prevState) => {
                            const updatedFiles = prevState.files.map((f, idx) => {
                                if (idx === index) {
                                    return { ...f, status: 'Failed' };
                                }
                                return f;
                            });
                            return { files: updatedFiles };
                        });
                        return {
                            fileID: presigned.fileID,
                            success: false,
                        };
                    }
                });

                const uploadResults = await Promise.all(uploadPromises);

                console.log('Upload results:', JSON.stringify(uploadResults, null, 2));
                console.log('Presigned URLs:', JSON.stringify(presignedUrls, null, 2));

                // Step 3: Notify server that uploads are complete
                // Use regular auth token since upload token was invalidated after post creation
                const completeResponse = await axios.post(
                    `${process.env.REACT_APP_API_URL}api/v2/create/post/complete`,
                    {
                        postID,
                        uploadedFiles: uploadResults,
                    },
                    {
                        headers: { 'x-auth-token': getToken() },
                    }
                );

                if (completeResponse.data.valid) {
                    this.setState({
                        acceptedFiles: completeResponse.data.files,
                        rejectedFiles: completeResponse.data.rejected,
                        submitted: true,
                    });

                    // Poll for completion status
                    var interval = setInterval(() => {
                        axios.get(`${process.env.REACT_APP_API_URL}api/v2/create/post/${postID}`, {
                            headers: { 'x-auth-token': getToken() }
                        }).then((res) => {
                            console.log(res.data);
                            // Update acceptedFiles with API response
                            this.setState({ acceptedFiles: res.data.post.content });
                            
                            // Update files state with API status for each file
                            if (res.data.post && res.data.post.content) {
                                // Create map of fileID to API file data
                                const apiFileMap: { [key: string]: any } = {};
                                res.data.post.content.forEach((apiFile: any) => {
                                    apiFileMap[apiFile.id] = apiFile;
                                });

                                this.setState((prevState: any) => ({
                                    apiFileStatuses: apiFileMap,
                                    files: prevState.files.map((localFile: any) => {
                                        // Use fileID stored in localFile to match with API response
                                        const fileID = localFile.fileID;
                                        
                                        // Get API file data by fileID
                                        const apiFile = fileID ? apiFileMap[fileID] : null;
                                        
                                        if (apiFile) {
                                            // Update status from API
                                            const apiStatus = apiFile.status || localFile.status;
                                            const showProgress = apiStatus === 'Uploading' || apiStatus === 'Preparing...';
                                            
                                            return {
                                                ...localFile,
                                                status: apiStatus,
                                                // Show progress only during upload, otherwise show completion or hide
                                                progress: showProgress 
                                                    ? (localFile.progress || 0)
                                                    : apiStatus === 'Complete' 
                                                        ? 100 
                                                        : undefined,
                                                estimatedTime: showProgress ? localFile.estimatedTime : undefined,
                                            };
                                        }
                                        
                                        // Fallback: try to match by filename if fileID is missing
                                        const localFileName = localFile.name || localFile.file?.name || '';
                                        const apiFileByFilename = res.data.post.content.find((apiFileItem: any) => {
                                            return apiFileItem.filename === localFileName || 
                                                   apiFileItem.originalName === localFileName;
                                        });
                                        
                                        if (apiFileByFilename) {
                                            const apiStatus = apiFileByFilename.status || localFile.status;
                                            const showProgress = apiStatus === 'Uploading' || apiStatus === 'Preparing...';
                                            
                                            return {
                                                ...localFile,
                                                fileID: apiFileByFilename.id, // Store fileID for future updates
                                                status: apiStatus,
                                                progress: showProgress 
                                                    ? (localFile.progress || 0)
                                                    : apiStatus === 'Complete' 
                                                        ? 100 
                                                        : undefined,
                                                estimatedTime: showProgress ? localFile.estimatedTime : undefined,
                                            };
                                        }
                                        
                                        return localFile;
                                    })
                                }));
                            }
                            
                            if (res.data.complete === true) {
                                clearInterval(interval);
                                window.onbeforeunload = null;
                                window.location.href = `/app/user/${res.data.username}`;
                            }
                        }).catch(err => {
                            console.log(err);
                            clearInterval(interval);
                            window.onbeforeunload = null;
                        });
                    }, 5000);

                    toast.success('Post uploaded successfully!', {
                        style: {
                            color: '#ffffff',
                            backgroundColor: '#242C37',
                        }
                    });
                } else {
                    throw new Error('Failed to complete upload');
                }
            } catch (err: any) {
                console.log(err);
                this.setState((prevState) => {
                    const updatedFiles = prevState.files.map((file) => {
                        return { ...file, status: "Failed" };
                    });
                    return { files: updatedFiles };
                });
                toast.error(err.response?.data?.error || 'Failed to upload post!', {
                    style: {
                        color: '#ffffff',
                        backgroundColor: '#242C37',
                    }
                });
                // Re-enable form on error
                this.title.current.disabled = false;
                this.description.current.disabled = false;
                this.fileUpload.current.disabled = false;
                this.submitBTN.current.classList.toggle('hidden');
                if (hasFiles) {
                    this.price.current.disabled = false;
                    if (document.getElementById('price-input')) {
                        var price = document.getElementById('price-input') as HTMLInputElement;
                        price.disabled = false;
                    }
                }
            }
    }

    formatTime(seconds: number) {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}m ${remainingSeconds}s`;
    }

    render() {

        const currencyMask = createNumberMask({
            prefix: '$',
            suffix: '',
            includeThousandsSeparator: true,
            thousandsSeparatorSymbol: ',',
            allowDecimal: true,
            decimalSymbol: '.',
            decimalLimit: 2, // how many digits allowed after the decimal
            integerLimit: 7, // limit length of integer numbers
            allowNegative: false,
            allowLeadingZeroes: false,
        });

        function formatFileSize(bytes: any, decimalPoint: any = 2) {
            if(bytes === 0) return '0 Bytes';
            var k = 1000,
                dm = decimalPoint || 2,
                sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        }

        var types = {
            'image/png': ['.png'],
            'image/jpeg': ['.jpeg', '.jpg'],
            'video/mp4': ['.mp4', '.mov', '.avi', '.mkv'],
            'video/quicktime': ['.mov'],
            'video/webm': ['.webm'],
            'audio/mpeg': ['.mp3'],
        }

        return <div className="col-span-2 mb-2">
            <Toaster position="bottom-center" />
            
            {/* Free Plan Banner */}
            {this.state.isFreePlan && (
                <div className="bg-yellow-600 text-white px-4 py-3 mt-4 rounded-md mb-4 flex items-center justify-between">
                    <div>
                        <p className="font-semibold">No plans are set up yet</p>
                        <p className="text-sm mt-1">Each user can follow you for free.</p>
                    </div>
                    <button 
                        onClick={() => window.location.href = '/app/creator'} 
                        className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 transition-colors ml-4 flex-shrink-0"
                    >
                        Set Up Plans
                    </button>
                </div>
            )}
            
            <form onSubmit={(e) => this.submitForm(e)}>
                <h1 className="text-2xl font-bold mt-3">Create a Post</h1>
                <h1 className="text-xl font-bold pt-4">Title</h1>
                <input onChange={(e) => this.setState({title: e.target.value})} ref={this.title} type="text" placeholder="Title" className="w-full bg-gray-800 disabled:bg-gray-700 rounded-md px-4 py-2 my-4" />
                <h1 className="text-xl font-bold pt-2">Description</h1>
                <textarea onChange={(e) => this.setState({description: e.target.value})} ref={this.description} placeholder="Description" className="w-full bg-gray-800 disabled:bg-gray-700 rounded-md px-4 py-2 my-4"></textarea>
                <h1 className="text-xl font-bold">Price</h1>
                <MaskedInput id="price-input" ref={this.price} mask={currencyMask} onChange={(e) => this.costPrice(e.target.value)} className="bg-gray-800 disabled:bg-gray-700 mt-4 my-2 px-2 py-2 rounded-md text-right w-full" placeholder={`$0.00`} />
                <div id="fees" className="flex grid grid-rows float-right">
                    <span className="float-right">Platform Fees (20%): <span className="text-gray-200 float-right px-4">-{(() => {
                        if (this.state.value === 0) {
                            return "";
                        } else {
                            var fees = this.state.value * 0.20;
                            var rounded = Math.round(fees * 100) / 100;
                            return `$${rounded}`;
                        }
                    })()}</span></span>
                    <span className="float-right">Total Earnings: <span className="text-gray-200 float-right px-4 font-bold">${(() => {
                        if (this.state.value === 0) {
                            return "0.00";
                        } else {
                            var total = this.state.value - (this.state.value * 0.20);
                            var rounded = Math.round(total * 100) / 100;
                            return rounded;
                        }
                    })()}</span></span>
                </div>

                {/* iOS Pricing Preview */}
                {this.state.value > 0 && (() => {
                    const webPrice = this.state.value;
                    const markupMultiplier = 1.30;
                    const appleFeePercent = 30;
                    const platformFeePercent = 20;
                    const iosPrice = Math.round(webPrice * markupMultiplier * 100) / 100;
                    const appleCut = Math.round(iosPrice * (appleFeePercent / 100) * 100) / 100;
                    const proceeds = iosPrice - appleCut;
                    const platformCut = Math.round(proceeds * (platformFeePercent / 100) * 100) / 100;
                    const creatorNetIOS = Math.round((proceeds - platformCut) * 100) / 100;

                    return (
                        <div className="mt-4 mb-2 bg-gray-800/50 border border-gray-700 rounded-lg p-4">
                            <div className="flex items-center gap-2 mb-3">
                                <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                                </svg>
                                <span className="text-sm font-medium text-gray-400">iOS In-App Purchase</span>
                            </div>
                            <div className="grid grid-cols-2 gap-3 text-sm">
                                <div>
                                    <span className="text-gray-500">iOS price:</span>
                                    <span className="text-white font-medium ml-2">${iosPrice.toFixed(2)}</span>
                                </div>
                                <div>
                                    <span className="text-gray-500">Your net (iOS):</span>
                                    <span className="text-white font-medium ml-2">~${creatorNetIOS.toFixed(2)}</span>
                                </div>
                                <div className="col-span-2 text-xs text-gray-500">
                                    iOS price = web price + 30% markup. Apple takes 30%, platform takes 20% of proceeds.
                                </div>
                            </div>
                        </div>
                    );
                })()}

                <h1 className="text-xl font-bold mt-10">Attach Media</h1>
                <Dropzone onDrop={this.onDrop} ref={this.fileUpload} accept={types}>
                    {({getRootProps, getInputProps}) => (
                        <section className="flex flex-col justify-center items-center mt-4">
                            <div {...getRootProps({className: 'dropzone'})} className="flex bg-gray-800 disabled:bg-gray-700 w-full text-center justify-center h-20 rounded-md items-center">
                                <input {...getInputProps()} />
                                <p className="m-0">Drag 'n' drop some files here, or click to select files</p>
                            </div>
                        </section>
                    )}
                </Dropzone>
                
                {/* <aside className="mt-4">
                    <h4 className="text-2xl font-bold">Files</h4>
                    <table className="table-fixed w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 mt-4">
                        <thead className="text-xs text-white uppercase bg-gray-900">
                            <tr>
                                <th scope="col" className="px-6 py-3">
                                    File Name
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    Size
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    Status
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {(() => {
                                if (this.state.submitted === true) {
                                    return this.state.acceptedFiles.map((file: any) => (
                                        <tr key={file.path} className="bg-gray-800 border-b">
                                            <th className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white truncate">{file.filename}</th>
                                            <th className="px-6 py-4">{formatFileSize(file.size)}</th>
                                            <th className="px-6 py-4">{file.status}</th>
                                        </tr>
                                    ))
                                } else {
                                    return this.state.files.map((file: any) => {
                                        console.log(file)
                                        return <tr key={file.path} className="bg-gray-800 border-b">
                                            <th className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white truncate">{file.name}</th>
                                            <th className="px-6 py-4">{formatFileSize(file.size)}</th>
                                            <th className="px-6 py-4">Idle</th>
                                        </tr>
                                    })
                                }
                            })()}
                            {(() => {
                                if (this.state.submitted === true) {
                                    if (this.state.rejectedFiles.length > 0) {
                                        return <h1 className="text-2xl text-white font-bold mt-4 mb-2">Failed Files</h1>
                                    }
                                }
                            })()}
                            {(() => {
                                if (this.state.submitted === true) {
                                    if (this.state.rejectedFiles.length > 0) {
                                        return this.state.rejectedFiles.map((file: any) => (
                                            <tr key={file.path} className="bg-gray-800 border-b">
                                                <th className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{file}</th>
                                                <th className="px-6 py-4"></th>
                                                <th className="px-6 py-4">Failed - File type not allowed</th>
                                            </tr>
                                        ))
                                    }
                                }
                            })()}
                        </tbody>
                    </table>
                </aside> */}

                <aside className="mt-4">
                    <h4 className="text-2xl font-bold">Files</h4>
                    <table className="table-fixed w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 mt-4">
                        <thead className="text-xs text-white uppercase bg-gray-900">
                            <tr>
                                <th scope="col" className="px-6 py-3">File Name</th>
                                <th scope="col" className="px-6 py-3">Size</th>
                                <th scope="col" className="px-6 py-3">Status</th>
                                <th scope="col" className="px-6 py-3">Progress</th>
                                <th scope="col" className="px-6 py-3">Time Remaining</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.files.map((file: any, index: number) => {
                                // Extract file information - handle both File objects and wrappers
                                const fileName = file.name || file.file?.name || 'Unknown';
                                const fileSize = file.size || file.file?.size || 0;
                                const fileStatus = file.status || 'Pending';
                                const fileProgress = file.progress !== undefined ? file.progress : 0;
                                const fileEstimatedTime = file.estimatedTime || '';
                                
                                // Show progress bar only during upload phase
                                const showProgress = fileStatus === 'Uploading' || 
                                                   fileStatus === 'Preparing...' || 
                                                   (fileProgress > 0 && fileProgress < 100 && fileStatus !== 'Complete');
                                
                                return (
                                    <tr key={fileName + index} className="bg-gray-800 border-b">
                                        <th className="px-6 py-4">{fileName}</th>
                                        <th className="px-6 py-4">{formatFileSize(fileSize)}</th>
                                        <th className="px-6 py-4">{fileStatus}</th>
                                        <th className="px-6 py-4">
                                            {showProgress ? (
                                                <>
                                                    {/* Custom progress bar */}
                                                    <div className="w-full bg-gray-300 rounded-full h-2">
                                                        <div
                                                            className={`h-2 rounded-full bg-red-600`}
                                                            style={{ width: `${fileProgress}%` }}
                                                        ></div>
                                                    </div>
                                                    {fileProgress}%
                                                </>
                                            ) : fileStatus === 'Complete' ? (
                                                <span className="text-green-500">100%</span>
                                            ) : (
                                                <span>-</span>
                                            )}
                                        </th>
                                        <th className="px-6 py-4">{showProgress ? fileEstimatedTime : '-'}</th>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </aside>

                <button ref={this.submitBTN} type="submit" className="w-full bg-red-600 text-white rounded-md mt-8 h-8">Upload Post</button>
            </form>

            {/* Price Warning Modal */}
            {this.state.showPriceWarningModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4">
                        <h2 className="text-xl font-bold text-white mb-4">Price Warning</h2>
                        <p className="text-gray-300 mb-6">
                            You've set a price for this post, but prices only apply to posts with media files attached. 
                            This post will be created as a free post.
                        </p>
                        <div className="flex gap-4 justify-end">
                            <button
                                onClick={this.handleModalCancel}
                                className="px-4 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-600"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={this.handleModalConfirm}
                                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                            >
                                Continue Without Price
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    }
}